ACC.register = {

    _autoload: [
        ["passwordStrength", $('.amds-password-strength').length > 0],
        "registerClientChoice",
        "checkFormFieldsType",
        "checkInputNumberType",
        "validateForm",
        "passwordChange",
        "initRegisterEvent",
        "redirectToCorrectClientType",
        "showPassword",
        "disablePaste",
        "majActivated",
        "ignoreWhiteSpaces",
        "registerClientCountry"
    ],

    validateFormID: '.validateForm',
    validateFormFields: $('.validateForm .amds-form-field'),
    formFieldValidationClass: 'amds-form-field-validation',
    formFieldValidationErrorClass: 'amds-form-field-validation-error',
    formFieldDisabledClass: 'amds-form-field-disabled',
    formFieldErrorMsg: 'amds-form-field__errormsg',
    formStep: '.step-form',
    searchElm: '.EHID-request',
    currentStep: 1,
    pageReloaded: false,
    // Minimum 8 characters at least 1 Alphabet uppercase and 1 lowercase
    passwordRegex: /^(?=.*[A-Z])(?=.*[a-z])\S{8,}$/,
    triggerSubmit: false,
    capsLockEnabled: null,


    registerClientChoice: function () {
        /* Contentsquare */
        $(document).ready(function () {
            if ($('#client-choice-entreprise').length) {
                setTimeout(function () {
                    ACC.track.contentsquareAPVTracking("client-choice-business");
                }, 1500);

            }
        });
        /* Contentsquare */
        $('.client-choices').on('click', '.client-choice label', function () {
            var that = $(this),
                type = that.parent().data('type');
            /* Contentsquare */
            switch (type) {
                case 'entreprise':
                    ACC.track.contentsquareAPVTracking("client-choice-business");
                    break;
                case 'administration':
                    ACC.track.contentsquareAPVTracking("client-choice-administration");
                    break;
                case 'particulier':
                    ACC.track.contentsquareAPVTracking("client-choice-individual");
                    break;
            }
            /* Contentsquare */

            $('input[name=clientNonAgenceType]').val(type);
            ACC.register.checkFormFieldsType(ACC.register.validateFormFields, type);
            ACC.register.showIdNumberInput($('#countryIsoCode'));
            ACC.register.checkFormType(type);

            if (!ACC.register.pageReloaded) {
                ACC.register.clearForm();
            }
            ACC.register.pageReloaded = false;
        });
    },

    checkInputNumberType: function (inputs) {

        if (!inputs) {
            var inputs = $('.input-number');
        }

        if (inputs.length > 0) {

            $.each(inputs, function (index, input) {
                if (ACC.register.isTouchDevice()) {
                    $(input).get(0).type = 'number';
                }
                $(input).on("keypress", function (event) {
                    $(this).val($(this).val().replace(/\s/g, '').replace(/[^\d].+/, ""));
                    if ((event.which < 48 || event.which > 57) && event.which != 13) {
                        ACC.register.showError($(this), errorsMsg['number']['notvalid']);
                    } else {
                        ACC.register.hideError($(this));
                    }
                });
                $(input).on("blur", function (event) {
                    var regex = /^([0-9])+$/;
                    if ($(this).val().length > 0 && !regex.test($(this).val().replace(/\s/g, ''))) {
                        ACC.register.showError($(this), errorsMsg['number']['notvalid']);
                    } else {
                        ACC.register.hideError($(this));
                    }
                });
            })

        }
    },

    showError: function (input, msg) {
        event.preventDefault();
        if ($(input).siblings('.' + ACC.register.formFieldErrorMsg).length > 0) {
            $(input).siblings('.' + ACC.register.formFieldErrorMsg).hide().html(msg).slideDown(0);
        } else if (!$(input).hasClass(ACC.register.formFieldValidationErrorClass)) {
            $("<label class='error' />").insertAfter(input).html(msg);
        }
        $(input).addClass(ACC.register.formFieldValidationErrorClass);

    },

    hideError: function (input) {
        $(input).removeClass(ACC.register.formFieldValidationErrorClass);
        if ($(input).siblings('.' + ACC.register.formFieldErrorMsg).length > 0) {
            $(input).siblings('.' + ACC.register.formFieldErrorMsg).slideUp(0);
        } else if (!$(input).hasClass(ACC.register.formFieldValidationErrorClass)) {
            $(input).siblings('.error').remove();
        }
    },

    isTouchDevice: function () {
        return 'ontouchstart' in document.documentElement;
    },

    checkFormType: function (type) {
        var $registerPage = $('.registerPage');
        var $registerOldForm = $('.register-old-style');
        var $registerNewForm = $('.register-new-style');

        if (type && type === 'entreprise') {
            $registerPage.addClass('register-style');
            $registerOldForm.hide();
            $registerNewForm.show();
        } else {
            $registerPage.removeClass('register-style');
            $registerOldForm.show();
            $registerNewForm.hide();
        }
    },

    checkFormFieldsType: function (fields, type) {
        if (!fields) {
            var fields = $('.amds-form-field');
        }

        if (!type) {
            var type = $('input[name=client-choice]:checked').val();
        }

        if (type) {

            $('h3.administration, .group.administration').toggleClass('hidden', (type !== 'administration') );

            $.each(fields, function (index, field) {
                if($(field).data('type') !== undefined) {
                    var fieldTypes = $(field).data('type').split('-');

                    if (!Array.prototype.includes) {
                        Array.prototype.includes = function () {
                            'use strict';
                            return String.prototype.indexOf.apply(this, arguments) !== -1;
                        };
                    }

                    if (fieldTypes.includes(type) || fieldTypes[0] === 'all') {
                        $(field).find('input, select').prop("disabled", false);
                        $(field).removeClass(ACC.register.formFieldDisabledClass).show();
                    } else {
                        $(field).find('input, select').prop("disabled", true);
                        $(field).addClass(ACC.register.formFieldDisabledClass).hide();
                    }
                }

            });
        }
    },

    redirectToCorrectClientType: function () {
        var type = $('input[name=clientNonAgenceType]').val();

        if (type != "" && type != "entreprise") {
            ACC.register.pageReloaded = true;
            $('.client-choice label[for="client-choice-' + type + '"]').click();
        } else if (type != "" && type === "entreprise" && $('.step-form .amds-form-field__errormsg span[id$=".errors"]').length) {
            ACC.register.goToErrorStep();
        }
    },

    validateForm: function () {
        $(document).on('submit', ACC.register.validateFormID, function (e) {

            // If this form was already submitted successfully
            if ($(this).data('alreadySubmitted')) {
                e.preventDefault();
                $('.submit-error-message').show();
                return false;
            }
            if (e.target.id === "addressForm" && ACC.address.isAddressRemovalSubmit(e)) {
                return true;
            }
            var $fields = $(this).find('.amds-form-field');

            if ($(this).find('.alert.negative').length > 0) {
                $(this).find('.alert.negative').slideUp(200);
            }

            var isError = false,
                conditionCheckbox = $(this).find('.accept-conditions input[type=checkbox]');

            $.each($fields, function (index, field) {
                var that = $(field),
                    fieldClass = that.attr('class').split(' ');

                if (!that.hasClass(ACC.register.formFieldDisabledClass)) {
                    $.each(fieldClass, function (index, classString) {
                        var validationClass = ACC.register.formFieldValidationClass + '__',
                            isErrorField = false;

                        if (classString.toLowerCase().indexOf(validationClass) != -1) {
                            isErrorField = ACC.register.validateFormField(classString.split(validationClass)[1], that);
                        }

                        if (isErrorField) {
                            isError = true;
                        }
                    });
                }
            });

            if (conditionCheckbox.length && ACC.register.validateFormField('conditions', conditionCheckbox)) {
                isError = true;
            }

            if (isError) {
                if ($.inArray($(this).attr('id'), ['resetPasswordForm', 'updatePasswordForm']) == -1) {
                    ACC.register.goTo($(ACC.register.validateFormID).offset().top + -80);
                }

                return false;
            } else if (!ACC.register.triggerSubmit && $('#hasPOSinSession').val() === 'false' && $("body").hasClass('page-clientNonAgenceRegisterPage')) {
                ACC.storefinderPopin.openStoreFinderPopinModal(true);
            } else if ((e.target.id === "addressForm" && $("#certify").is(':checked'))
                || (e.target.id === "updatePasswordForm")
                || (e.target.id === "resetPasswordForm")) {
                return true;
            }

            if (ACC.register.triggerSubmit
                || $('#hasPOSinSession').val() === 'true'
                || $("body").hasClass('page-clientAgenceRegisterPage')
                || $("body").hasClass('page-update-profile')
                || $("body").hasClass('page-P110')
                || $("body").hasClass('page-P120')
                || $("body").hasClass('page-resetPassword')
                || $("body").hasClass('page-updatePassword')) {
                   var clientNumber = $('#clientNumber').val();
                   var agency = $('#agency').val();
                   if ($.trim(clientNumber) !== '' && $.trim(agency) !== '') {
                       $(this).data('alreadySubmitted', true);
                   }
                   return true;
                }
            return false;
        });
    },

    validateFormField: function (validation, field) {
        var isError = false;

        switch (validation) {
            case 'mandatory':
                $.each(field.find('input, select, textarea'), function (index, input) {
                    if (!$(input).hasClass('excluded') && $(input).val() === '') {
                        isError = true;
                        $(input).addClass(ACC.register.formFieldValidationErrorClass);

                        var errormsgDiv = $(input).siblings('.' + ACC.register.formFieldErrorMsg);

                        if ($(input).attr('id') == "password" || $(input).attr('id') == "amds-password") {
                            errormsgDiv = $(input).parent().find('.' + ACC.register.formFieldErrorMsg);
                        }

                        errormsgDiv.hide().html(errorsMsg['all']['mandatory']).slideDown();
                    } else {
                        if ($(input).attr('id') !== 'password' && $(input).attr('id') !== 'amds-password' && $(input).attr('id') !== 'confirm-password' && $(input).attr('id') !== 'amds-confirm-password') {
                            $(input).removeClass(ACC.register.formFieldValidationErrorClass);

                            var errormsgDiv = $(input).siblings('.' + ACC.register.formFieldErrorMsg);

                            if (($(input).attr('id') == "password" && $('#password_bar').length > 0) || ($(input).attr('id') == "amds-password" && $('#amds-password_bar').length > 0)) {
                                errormsgDiv = $(input).parent().find('.' + ACC.register.formFieldErrorMsg);
                                errormsgDiv.addClass("errorMsgMargin");
                            }

                            errormsgDiv.slideUp(100);
                        }
                    }
                });
                break;

            case 'email':
                var input = field.find('input'),
                    emailVal = input.val(),
                    regex = new RegExp(emailRegex);

                if (emailVal !== "") {
                    if (!regex.test(emailVal)) {
                        isError = true;
                        $(input).addClass(ACC.register.formFieldValidationErrorClass);
                        $(input).siblings('.' + ACC.register.formFieldErrorMsg).hide().html(errorsMsg['email']['notvalid']).slideDown();
                    } else {
                        $(input).removeClass(ACC.register.formFieldValidationErrorClass);
                        $(input).siblings('.' + ACC.register.formFieldErrorMsg).slideUp(100);
                    }
                }
                break;

            case 'password':
                var pass = field.find('input'),
                    passVal = pass.val();

                if (passVal !== "") {
                    if ($('#password_bar, #amds-password_bar', field).is(':visible')) {
                        $(pass).parent().find('.' + ACC.register.formFieldErrorMsg).addClass("errorMsgMargin");
                    }
                    if (passVal.match(ACC.register.passwordRegex) === null) {
                        isError = true;
                        $(pass).addClass(ACC.register.formFieldValidationErrorClass);
                        $(pass).parent().find('.' + ACC.register.formFieldErrorMsg).hide().html(errorsMsg['checkPwd']['notvalid']).slideDown();
                    } else {
                        $(pass).removeClass(ACC.register.formFieldValidationErrorClass);
                        $(pass).parent().find('.' + ACC.register.formFieldErrorMsg).slideUp(100);
                    }
                }
                break;

            case 'checkPwd':
                var pass = field.find('input'),
                    parent = field.parent(),
                    passConfirm = $('#confirm-password, #amds-confirm-password', parent),
                    passConfirmField = passConfirm.closest('.amds-form-field'),
                    passVal = pass.val(),
                    passConfirmVal = passConfirm.val(),
                    passValide = false,
                    passConfirmValide = false;

                if ($("body").hasClass('page-resetPassword') || $("body").hasClass('page-updatePassword')) {
                    passConfirm = $('#confirm-password');
                    passConfirmField = passConfirm.closest('.amds-form-field');
                    passConfirmVal = passConfirm.val();
                }

                if (passVal !== "") {
                    passValide = !ACC.register.validateFormField('password', field);
                }

                if (passConfirmVal !== "") {
                    passConfirmValide = !ACC.register.validateFormField('password', passConfirmField);
                }

                if (passValide && passConfirmValide) {
                    if (passVal != passConfirmVal) {
                        isError = true;
                        $(pass).addClass(ACC.register.formFieldValidationErrorClass);
                        $(pass).parent().find('.' + ACC.register.formFieldErrorMsg).hide().html(errorsMsg['checkPwd']['notidentical']).slideDown();
                        $(passConfirm).addClass(ACC.register.formFieldValidationErrorClass);
                        $(passConfirm).parent().find('.' + ACC.register.formFieldErrorMsg).hide().html(errorsMsg['checkPwd']['notidentical']).slideDown();
                    } else {
                        $(pass).removeClass(ACC.register.formFieldValidationErrorClass);
                        $(pass).parent().find('.' + ACC.register.formFieldErrorMsg).slideUp(100);
                        $(passConfirm).removeClass(ACC.register.formFieldValidationErrorClass);
                        $(passConfirm).parent().find('.' + ACC.register.formFieldErrorMsg).slideUp(100);
                    }
                } else {
                    isError = true;
                }
                break;

            case 'conditions':
                if (!field.is(':checked')) {
                    isError = true;
                    field.addClass(ACC.register.formFieldValidationErrorClass);
                    field.parent().find('.' + ACC.register.formFieldErrorMsg).hide().html(errorsMsg['all']['mandatory']).slideDown();
                } else {
                    field.removeClass(ACC.register.formFieldValidationErrorClass);
                    field.parent().find('.' + ACC.register.formFieldErrorMsg).slideUp(100);
                }
                break;

            case 'number':
                var input = field.find('input'),
                    inputVal = input.val(),
                    regex = /^([0-9])+$/;

                input.val(inputVal = $.trim(inputVal));

                if (inputVal !== "") {
                    if (!regex.test(inputVal)) {
                        isError = true;
                        $(input).addClass(ACC.register.formFieldValidationErrorClass);
                        $(input).siblings('.' + ACC.register.formFieldErrorMsg).hide().html(errorsMsg['all']['notvalid']).slideDown();
                    } else {
                        $(input).removeClass(ACC.register.formFieldValidationErrorClass);
                        $(input).siblings('.' + ACC.register.formFieldErrorMsg).slideUp(100);
                    }
                }
                break;

            case 'numClientAMDS':
                var input = field.find('input'),
                    inputVal = input.val(),
                    regex = /^([0-9]){1,10}$/; // max 10 number

                input.val(inputVal = $.trim(inputVal));

                if (inputVal !== "") {
                    if (!regex.test(inputVal)) {
                        isError = true;
                        $(input).addClass(ACC.register.formFieldValidationErrorClass);
                        $(input).siblings('.' + ACC.register.formFieldErrorMsg).hide().html(errorsMsg['all']['notvalid']).slideDown();
                    } else {
                        $(input).removeClass(ACC.register.formFieldValidationErrorClass);
                        $(input).siblings('.' + ACC.register.formFieldErrorMsg).slideUp(100);
                    }
                }
                break;

            case 'phone':
                var miniFields = field.find('.amds-form-field-mini');

                $.each(miniFields, function (index, miniField) {
                    var input = $(miniField).find('input'),
                        inputVal = input.val(),
                        regex = /^(\+|\d)[0-9]{7,16}$/;

                    input.val(inputVal = $.trim(inputVal));

                    if (inputVal !== "") {
                        if (!regex.test(inputVal)) {
                            isError = true;
                            $(input).addClass(ACC.register.formFieldValidationErrorClass);
                            $(input).siblings('.' + ACC.register.formFieldErrorMsg).hide().html(errorsMsg['all']['notvalid']).slideDown();
                        } else {
                            $(input).removeClass(ACC.register.formFieldValidationErrorClass);
                            $(input).siblings('.' + ACC.register.formFieldErrorMsg).slideUp(100);
                        }
                    }
                });
                break;
            case 'maxlength':
                var inputList = field.find('input');
                $.each(inputList, function (index, classString) {
                    var input = $(this),
                        inputVal = input.val(),
                        maxlengthVal = parseInt($(input).attr("class").substring($(input).attr("class").indexOf("maxlength_")).split(" ")[0].split("_")[1]);
                    if (inputVal.length > maxlengthVal) {
                        isError = true;
                        $(input).addClass(ACC.register.formFieldValidationErrorClass);
                        if ($(".form-group", field).length > 0) {
                            $(".amds-form-field__errormsg", field).html(maxlengthVal + " " + errorsMsg['all']['maxlength']).slideDown();
                        } else {
                            $(input).siblings('.' + ACC.register.formFieldErrorMsg).hide().html(maxlengthVal + " " + errorsMsg['all']['maxlength']).slideDown();
                        }
                    } else {
                        if ($(document).find('.amds-form-field-validation-error').length) {
                            $(this).removeClass("amds-form-field-validation-error");
                        }
                    }
                })
                break;

            case 'townCity':
                var input = field.find('.amds-form-field-mini').eq(1).find('input')
                var cityVal = input.val()

                if (cityVal !== "") {
                    if (cityVal.length > 35) {
                        isError = true;
                        $(input).addClass(ACC.register.formFieldValidationErrorClass);
                        $(input).siblings('.' + ACC.register.formFieldErrorMsg).hide().html(errorsMsg['townCity']['maxlength']).slideDown();
                    } else {
                        $(input).removeClass(ACC.register.formFieldValidationErrorClass);
                        $(input).siblings('.' + ACC.register.formFieldErrorMsg).slideUp(100);
                    }
                }
                break;

           case 'birthDate':
                var input = field.find('input'),
                    inputVal = input.val(),
                    pattern = new RegExp(input.attr('pattern')),
                    isRequired = input.hasClass('amds-form-field--required');
                    if ((isRequired && inputVal === "") || (inputVal !== "" && !pattern.test(inputVal))) {
                        $(input).siblings('.' + ACC.register.formFieldErrorMsg).removeClass('hidden');
                    }
                    if (isRequired && inputVal === "") {
                    isError = true;
                    input.addClass(ACC.register.formFieldValidationErrorClass);
                    field.find('.' + ACC.register.formFieldErrorMsg)
                        .hide()
                        .html(errorsMsg['all']['mandatory'])
                        .slideDown();
                } else if (inputVal !== "" && !pattern.test(inputVal)) {
                    isError = true;
                    input.addClass(ACC.register.formFieldValidationErrorClass);
                    field.find('.' + ACC.register.formFieldErrorMsg)
                        .hide()
                        .html(errorsMsg['birthDate']['notvalid'])
                        .slideDown();
                } else {
                    input.removeClass(ACC.register.formFieldValidationErrorClass);
                    field.find('.' + ACC.register.formFieldErrorMsg).slideUp(100);
                }
                break;

            case 'countryBirthIso':
            case 'agency':
                var select = field.find('select'),
                    selectedVal = select.val(),
                    isRequired = select.hasClass('amds-form-field--required'); // Check on <select> itself

                if (isRequired && !selectedVal) {
                    isError = true;
                    select.addClass(ACC.register.formFieldValidationErrorClass);
                    field.find('.' + ACC.register.formFieldErrorMsg)
                        .hide()
                        .html(errorsMsg['all']['mandatory'])
                        .slideDown();
                } else {
                    select.removeClass(ACC.register.formFieldValidationErrorClass);
                    field.find('.' + ACC.register.formFieldErrorMsg).slideUp(100);
                }
                break;
            case 'deliveryAddress':
                var input = field.find('input'),
                    inputVal = input.val();

                if (inputVal !== "") {
                    if (inputVal.length > 60) {
                        isError = true;
                        $(input).addClass(ACC.register.formFieldValidationErrorClass);
                        field.find('.' + ACC.register.formFieldErrorMsg)
                            .hide()
                            .html(errorsMsg['deliveryAddress']['maxlength'])
                            .slideDown();
                    } else {
                        $(input).removeClass(ACC.register.formFieldValidationErrorClass);
                        field.find('.' + ACC.register.formFieldErrorMsg).slideUp(100);
                    }
                }
                break;
        }

        return isError;
    },

    passwordChange: function () {
        $('#password, #amds-password').on('keyup', function () {
            $(this).removeClass(ACC.register.formFieldValidationErrorClass);
            $(this).parent().find('.' + ACC.register.formFieldErrorMsg).slideUp(100);
        });
    },

    clearForm: function () {
        $('.' + ACC.register.formFieldValidationErrorClass).removeClass(ACC.register.formFieldValidationErrorClass);
        $('.' + ACC.register.formFieldErrorMsg).hide().html('');
    },

    goTo: function (position) {
        $("html, body").animate({scrollTop: position}, 'slow');
    },

    showPassword: function () {
        $(document).on('change', '#show-pwd, #amds-show-pwd', function () {
            $form = $(this).closest('form');

            if (this.checked) {
                $(".amds-form-field__password", $form).each(function () {
                    this.type = "text"
                });
            } else {
                $(".amds-form-field__password", $form).each(function () {
                    this.type = "password"
                });
            }
        });
    },

    disablePaste: function () {
        $(".amds-form-field__dpaste").each(function () {
            $(this).on('cut copy paste', function (e) {
                e.preventDefault();
            });

        });
    },

    majActivated: function () {
        $(document).on('keydown', function (e) {
            e = e || event;
            if (e.keyCode == 20 && ACC.register.capsLockEnabled !== null) {
                ACC.register.capsLockEnabled = !ACC.register.capsLockEnabled;
            }
        });
        $(document).on('keypress', function (e) {
            e = e || event;

            var chr = ACC.register.getChar(e);
            if (!chr) return; // special key

            if (chr.toLowerCase() == chr.toUpperCase()) {
                return;
            }

            ACC.register.capsLockEnabled = (chr.toLowerCase() == chr && e.shiftKey) || (chr.toUpperCase() == chr && !e.shiftKey);
        });
        $(".amds-form-field__password").each(function () {
            $(this).on('keyup focus', function (e) {
                if (ACC.register.capsLockEnabled) {
                    $(this).siblings('.' + ACC.register.formFieldErrorMsg).html(errorsMsg['all']['password']).show();
                }
            })
            $(this).on('blur', function (e) {
                $(this).siblings('.' + ACC.register.formFieldErrorMsg).slideUp();
            })
        });
    },

    getChar: function (e) {

        if (e.which == null) {
            return String.fromCharCode(e.keyCode); // IE
        }
        if (e.which != 0 && e.charCode != 0) {
            return String.fromCharCode(e.which); // rest
        }

        return null;
    },

    ignoreWhiteSpaces: function () {
        $('#num-tva, #VAT-number').bind('input', function () {
            $(this).val(function (_, v) {
                return v.replace(/\s+/g, '');
            });
        });
        $('#num-id, #amds-num-id').bind('input', function () {
            $(this).val(function (_, v) {
                return v.replace(/\s+/g, '');
            });
        });
        $('#email, #amds-email').bind('input', function () {
            $(this).val(function (_, v) {
                return v.replace(/\s+/g, '');
            });
        });
        $('#password, #amds-password').bind('input', function () {
            $(this).val(function (_, v) {
                return v.replace(/\s+/g, '');
            });
        });
        $('#confirm-password, #amds-confirm-password').bind('input', function () {
            $(this).val(function (_, v) {
                return v.replace(/\s+/g, '');
            });
        });
    },

    registerClientCountry: function () {
        $('#amds-countryIsoCode').on('change', function () {
            ACC.register.showIdNumberInput();
        });
    },

    showIdNumberInput: function () {
        if ( $('select#amds-countryIsoCode option').filter(":selected").data('idnumber') && $('input[name=clientNonAgenceType]').val() === 'particulier') {
            $('.amdsIdNumber').find('input, select').prop("disabled", false);
            $('.amdsIdNumber').removeClass(ACC.register.formFieldDisabledClass).show();
        } else {
            $('.amdsIdNumber').find('input, select').val('');
            $('.amdsIdNumber').find('input, select').prop("disabled", true);
            $('.amdsIdNumber').addClass(ACC.register.formFieldDisabledClass).hide();
        }
    },

    passwordStrength: function () {
        $('.amds-password-strength').pstrength({
            verdicts: [ACC.pwdStrengthTooShortPwd,
                ACC.pwdStrengthVeryWeak,
                ACC.pwdStrengthWeak,
                ACC.pwdStrengthMedium,
                ACC.pwdStrengthStrong,
                ACC.pwdStrengthVeryStrong],
            minCharText: ACC.pwdStrengthMinCharText,
            minPass: 8,
            minchar: 1
        });
    },

    goToErrorStep: function () {
        if ($(ACC.register.searchElm + ' .amds-form-field__errormsg span[id$=".errors"]').length) return;
        $(".step-form .js-btn-search-organisation").click();
    },

    initRegisterEvent: function () {
        $('#amds-password_bar').insertAfter('.amds-pass-info');

        $('#VAT-number').keyup(function () {
            $(this).val($(this).val().toUpperCase());
        });

        $(".step-form .js-btn-search-organisation").on("click", function (e) {
            var $vatElm = $("#VAT-number"),
                reg = new RegExp($vatElm.attr('pattern')),
                amdsVatErrorMessage = '.amds-form-field__errormsg',
                vatID = $.trim($vatElm.val());

            if (!$vatElm.length || ACC.register.validateFormField('mandatory', $(ACC.register.searchElm))) {
                $vatElm.addClass('amds-form-field-validation-error').parent().find(amdsVatErrorMessage).html($(amdsVatErrorMessage).data('validation-empty-msg')).slideDown();
                console.log('vvvvvv')
                return
            }
            console.log(reg,vatID,reg.test(vatID))

            if (!reg.test(vatID)) {
                console.log('ttttttttttt')
                $vatElm.addClass('amds-form-field-validation-error').parent().find(amdsVatErrorMessage).html($(amdsVatErrorMessage).data('validation-error-msg')).slideDown();
            } else {
                ACC.register.searchOrganisation(vatID);
            }
        });

       $("#clientNumber").on("input", function () {
           this.value = this.value.replace(/\D/g, "");
       });

        $("#VAT-number").on("keydown", function (e) {
            if (e.keyCode !== 13) return;
            e.preventDefault();
            if (ACC.register.validateFormField('mandatory', $(ACC.register.searchElm))) return;
            var vatID = $.trim(e.currentTarget.value);
            ACC.register.searchOrganisation(vatID);
        });

        $(".step-form .js-amds-btn-update-company").on("click", function (e) {
            ACC.register.showStep(1);
            ACC.register.clearForm();
        });

        $(".step-form .js-amds-btn-back").on("click", function (e) {
            if (ACC.register.currentStep !== 2) return;
            e.preventDefault();
            ACC.register.showStep(1);
            ACC.register.clearForm();
            ACC.register.goTo($(ACC.register.formStep).offset().top + -80);
        });

        if ($(".step-form .step-right.dynamic-step").data('has-error') === true) {
            $(".step-form .js-btn-search-organisation").trigger("click")
        }

    },

    showStep: function (stepNumber = 1) {
        $targetStep = $('.step-form .dynamic-step[data-step="' + stepNumber + '"]')
        $activeStep = $('.step-form .dynamic-step.active-step');

        ACC.register.currentStep = stepNumber

        $targetStep.addClass('active-step')
        $activeStep.removeClass('active-step')
    },

    updateComanyInfo: function (details = {}, vatID = '', empty = false) {
        var $detailsElm = $('.company-info .details');
        var detailTpl = '';
        var $companyName = $('#amds-company-name');

        if (empty) {
            detailTpl += '<p>' + $detailsElm.data('tva-label') + ' : <strong class="hightlight">' + vatID + '</strong></p>';
            detailTpl += '<p class="empty">' + $detailsElm.data('empty-msg') + '</p>';
            $companyName.val('');
            $companyName.parent().show();
        } else {
            detailTpl += '<p class="company-title">' + details.companyName + '</p>';
            detailTpl += '<p>' + $detailsElm.data('tva-label') + ' : <strong class="hightlight">' + vatID + '</strong></p>';
            detailTpl += '<address>';
            detailTpl += details.streetNumber + ' ' + details.streetName + '<br />';
            detailTpl += details.postCode + ' ' + details.city + '<br />';
            detailTpl += details.country;
            detailTpl += '</address>';

            $companyName.val(details.companyName);
            $companyName.parent().hide();
        }

        $detailsElm.html(detailTpl);
    },

    searchOrganisation: function (vatID = '') {
        var $searchElm = $(ACC.register.searchElm);
        if (!$searchElm.length || ($searchElm.length && $searchElm.hasClass('loader'))) return;
        $searchElm.addClass('loader')
        $.ajax({
            url: ACC.config.searchOrganisation,
            type: 'GET',
            dataType: "json",
            data: {vatID: vatID},
            success: function (response) {
                let formFieldErrorMsg = $('.' + ACC.register.formFieldErrorMsg);
                if (response.error === 1) {
                    let errorValidationMsg = formFieldErrorMsg.data('validation-error-msg');
                    $('.' + ACC.register.formFieldErrorMsg).text(errorValidationMsg).slideDown();
                }else if (response.error === 2) {
                    ACC.register.updateComanyInfo(null, vatID, true);
                    ACC.register.showStep(2)
                }else {
                    let errorValidationMsg = formFieldErrorMsg.data('validation-error-msg');
                    formFieldErrorMsg.text(errorValidationMsg).slideUp();
                    ACC.register.updateComanyInfo(response, vatID, false);
                    ACC.register.showStep(2)
                }
            },
            error: function () {
                //  ACC.register.updateComanyInfo(null, vatID, true);
            },
            complete: function () {
                $searchElm.removeClass('loader');
            }
        });
    }
};
